import * as z from "zod";
import { hsaReconciliationCsvOutputSchema } from "./hsa-reconciliation-common";

/** Gale's per-order breakdown of one payout, as a CSV. Same access as `getHsaPayouts`. */
export const exportHsaPayoutCsv = {
  name: "exportHsaPayoutCsv" as const,
  input: z.object({ payoutId: z.string().min(1) }),
  output: hsaReconciliationCsvOutputSchema,
};
